module.exports = __webpack_public_path__ + "img/Record.b8a30e7f.svg";